<template>
    <a-result status="404" title="404" sub-title="您访问的页面不存在">
        <template #extra>
            <a-button type="primary" @click="toIndex">
                回到主页
            </a-button>
        </template>
    </a-result>
</template>
<script>
export default {
    name: 'UI404',
    methods: {
        toIndex() {
            this.$router.replace('/')
        }
    }
}
</script>
